import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useToasts } from 'react-toast-notifications';
import ClipLoader from "react-spinners/ClipLoader";

import { makeStyles } from "@material-ui/core/styles";
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import api from '../../services/api';

const styles = {
  iconInput: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2,
    marginLeft: 16
  },

  iconInputLogin: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2,
    marginLeft: 16
  },

  iconInputLoginEye: {
    fontSize: 22,
    color: '#bbbbbb',
    marginTop: -2,
    cursor: 'pointer',
    marginRight: 16
  },

  margin: {
    height: 50
  },

  cardTitleWhite: {
    fontSize: '31px',
    color: "#1989FF",
    textAlign: 'center'
  },

  gridContainer: {
    height: '100vh',
    width: '100%',
    marginTop: '-70px'
  },

  textInfo: {
    color: '#828282',
    height: '0px',
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: '700',
    marginTop: 10
  },
};

const useStyles = makeStyles(styles);

export default function ConfirmaDados() {
  const classes = useStyles();
  const history = useHistory();
  const { addToast } = useToasts();
  const [email, setEmail] = useState('');
  const [dtNascim, setDtNascim] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        let usuario = await api.getUsuario();
        if (usuario.success) {
          setEmail(usuario.data.email);
          setDtNascim(usuario.data.dtNascim);
          setLoading(false);
        } else {
          setLoading(false);
          if (usuario.statusCode === 401) {
            localStorage.clear();
            history.push("/");
          }
          addToast(usuario.message, { appearance: 'error' });
        }
      } catch (err) {
        setLoading(false);
        if (err.statusCode === 401) {
          localStorage.clear();
          history.push("/");
        }
        addToast(err.message, { appearance: 'error' });
      }
    })();
  }, [history, addToast]);

  const handleSignIn = async () => {
    if (!email) {
      addToast("Por favor, informe o Email!", { appearance: 'error' });
      return;
    }
    else if (!dtNascim) {
      addToast("Por favor, informe a Data de Nascimento!", { appearance: 'error' });
      return;
    }
    try {
      setLoading(true);
      let recupera = await api.confirmarDados(email, dtNascim);
      if (recupera.success) {
        setLoading(false);
        addToast("Dados confirmados com sucesso!", { appearance: 'success' });
        history.push("/registrar");
      } else {
        setLoading(false);
        addToast(recupera.message, { appearance: 'error' });
      }
    } catch (err) {
      setLoading(false);
      addToast(err.message, { appearance: 'error' });
    }
  };

  return (
    <div className={classes.gridContainer}>
      <GridContainer style={{ position: 'fixed', justifyContent: 'center', height: '100%', alignItems: 'center', textAlign: 'center', zIndex: 1 }} >
        <GridItem>
          <Card style={{
            backgroundColor: '#f8f9fd',
            borderRadius: 25,
            borderBottomLeftRadius: 25,
            borderBottomRightRadius: 25,
            borderTopLeftRadius: 25,
            borderTopRightRadius: 25,
            borderColor: '#C8C8C8',
            height: '390px',
            width: '380px',
            boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)'
          }}>
            <CardHeader style={{ height: '30px', marginTop: 20 }}>
              <h4 className={classes.cardTitleWhite} style={{
                fontWeight: 400,
                color: '#1989ff',
                fontSize: 22,
                lineHeight: '28px'
              }}>Por favor, confirme os dados a seguir!</h4>
            </CardHeader>

            <CardBody style={{ padding: 0, marginTop: 60 }}>
              <GridItem>
                <h2 className={classes.textInfo}>Informe o seu Email</h2>
                <FormControl xs={12} sm={12} md={12} style={{ marginTop: 20 }}>
                  <Input xs={12} sm={12} md={12}
                    style={{ width: 300 }}
                    autoFocus={false}
                    disableUnderline
                    placeholder="Email"
                    inputProps={{
                      value: email,
                      onChange: (event) => {
                        setEmail(event.target.value);
                      },
                    }}
                    startAdornment={
                      <InputAdornment position="start">
                        <i className="icon-email-action-unread" style={styles.iconInputLogin} />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </GridItem>

              <GridItem>
                <h2 className={classes.textInfo}>Informe a Data de Nascimento</h2>
                <FormControl xs={12} sm={12} md={12} style={{ marginTop: 20, marginBottom: 30 }}>
                  <Input xs={12} sm={12} md={12}
                    style={{ width: 300 }}
                    autoFocus={false}
                    disableUnderline
                    placeholder="Data de Nascimento"
                    inputProps={{
                      value: dtNascim,
                      onChange: (event) => { setDtNascim(event.target.value) },
                      type: "date"
                    }}
                    startAdornment={
                      <InputAdornment position="start">
                        <i className="icon-calendar" style={styles.iconInput} />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </GridItem>
            </CardBody>

            <CardFooter style={{ justifyContent: 'center', alignItems: 'baseline', height: '100px', display: 'grid', padding: 0 }}>
              <Button style={{ borderRadius: '25px', width: 180 }} onClick={() => handleSignIn()} color="primary" disabled={loading}>Enviar</Button>
            </CardFooter>

            <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
              <ClipLoader
                size={80}
                color={"#364e6b"}
                loading={loading}
                css={{ border: '8px solid', borderBottomColor: 'transparent' }}
              />
            </div>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
